import { EnterBottomExitBottom } from '@components/shared/Transitions'
import SwapSettings from './SwapSettings'
import { useState } from 'react'
import ShowSlippageSettingsButton from './ShowSlippageSettingsButton'

const SlippageSettings = () => {
  const [showSlippageSettings, setShowSlippageSettings] = useState(false)
  return (
    <>
      <EnterBottomExitBottom
        className="thin-scroll absolute bottom-0 left-0 z-20 size-full overflow-auto rounded-2xl bg-th-bkg-1 p-6 pb-0"
        show={showSlippageSettings}
      >
        <SwapSettings onClose={() => setShowSlippageSettings(false)} />
      </EnterBottomExitBottom>
      <ShowSlippageSettingsButton
        onClick={() => setShowSlippageSettings(true)}
      />
    </>
  )
}

export default SlippageSettings
